module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block6"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps-rw"
  }, [_vm._v("HAPTER")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps-rw"
  }, [_vm._v("NE")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/leftswoosh_rev1_svg_online.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/rightswoosh_rev1_svg_online.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dateline-rw",
    attrs: {
      "id": "dateline1"
    }
  }, [_vm._v("A Very Wintry Afternoon in London"), _c('br'), _vm._v("\nJanuary 1823")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p53"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("I")]), _vm._v(" suppose you prefer White’s,” Henry Winslow drawled.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("Robert Carlisle’s gaze drifted from the smoke curling from the tip of his cigar to the man sitting in the leather chair across from him in the smoking room at Brooks’s. Before them, a crackling fire warmed away the chill of the winter afternoon outside the large windows, whose gray sky once more threatened to snow.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("“I prefer here, with the real leaders of England,” Robert corrected casually. “Businessmen and merchants, traders, importers—the men who make England run.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("“Hear! Hear!” Winslow lifted his glass and gasped softly as he took a swallow.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("Robert popped the cigar between his teeth before Winslow could see his self-satisfied smile. In truth, he preferred Boodle’s, where the gambling required more skill, the stakes were higher, and the women allowed in through the rear entrance were more interesting. But he would gladly flatter the man’s choice of club because he needed Henry Winslow.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("Rather, he needed Winslow Shipping and Trade.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("He eased back in the chair and kicked his Hessians onto the fireplace fender, for all appearances the model of a confident businessman when he was actually anxious as hell. He’d been waiting two years for this. Two years of taking calculated risks to build his wealth and connections, purchasing unproven shares of ships from India and the Far East just so he would have a presence among the men who drove the auctions, buying and selling warehouses full of goods so he could make a name for himself among the traders…all of it coming to this moment. To prospects with the largest merchant company in the British Empire.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("He’d be damned if he let it slip away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("He drawled as nonchalantly as possible, “I’ve heard that you’re expanding your shipping routes.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("“Ha!” Winslow flicked his ash onto the floor. “Where did you hear that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("“I have good contacts.” The best, in fact. Winslow knew that, too, or he wouldn’t have invited him here in the first place. “I’ve also heard that you’re looking for a partner to help you do it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("“I am.” Winslow’s eyes gleamed, appreciating Robert’s bluntness. “I’m looking for new blood to energize my company. Someone with the drive and ambition to make a name for himself.” He pushed himself from his chair and stepped forward to the fire, to take the liberty of grasping the brass poker and stirring up the flames. “I have an extraordinary company, and I need extraordinary men to run it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("Robert smiled tightly. "), _c('i', [_vm._v("Extraordinary")]), _vm._v(", all right.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("Henry Winslow might have been an arrogant braggart, but as England’s most successful businessman, he had every right to be. The sole proprietor of Winslow Shipping and Trade, he was one of the few import merchants who had managed to emerge from the wars wealthier than before. All due to determination, a willingness to risk capital, and good old-fashioned luck. A titan of fortune and power, Winslow had never taken on a partner before, but Robert had thoroughly studied the company and knew that he would be the perfect man for it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("And that this partnership would be the answer to his prayers.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("“I’m offering a limited share, you understand.” Winslow puffed out his chest, a gesture more propriety than proud. “A small stake. Perhaps seven percent.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_vm._v("Robert’s eyes narrowed. Much smaller than he’d hoped. But it would do. For now. “You’ve never taken a partner before. Why now?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("Winslow stared into the fire. “Changes need to be made. A man who doesn’t recognize when it’s time to adjust his ways might as well retire.” He jabbed the poker at the logs, sending up a shower of sparks. “But the timing of it—"), _c('i', [_vm._v("daughters")]), _vm._v(".” He heaved a hard breath and shook his head. “How does a businessman ensure a legacy for his family when all he has are daughters?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("Robert didn’t answer. His own father hadn’t worried about such things. Instead, Richard Carlisle had concerned himself with character, hard work, and devotion to his family, and he never considered his daughter to be any less worthy than his sons. They were all his children, all equally able to earn his pride.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("And Robert was determined to do exactly that. He "), _c('i', [_vm._v("would")]), _vm._v(" become the kind of man his father could take pride in raising, and he would let nothing stop him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("“Perhaps one of them will marry a gentleman you can bring into your business.” For his own selfish sake, Robert prayed that both Winslow daughters were toothless, bald spinsters well into their third decade and beyond the possibility of marrying ambitious upstarts who might snag this opportunity away from him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("“Not into my business. Not sons-in-law,” Winslow grumbled as he replaced the poker, then slapped his hands together to remove the soot from his fingers. “You don’t know my daughters, do you, Carlisle?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("Robert shook his head. His usual female companionship fell more toward experienced widows than spinster daughters of trade merchants.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("“Their reputations precede them, I’m afraid.” Winslow folded his hands behind his back and stared grimly down into the flames, his round belly jutting out. “Their mother died when they were young, only ten and eight. I suppose I should have found them a stepmother who could have raised them into proper young ladies, as my late wife wanted. But the business needed my attention, and there was barely enough time to find an appropriate governess, let alone a wife.” He paused, then admitted, “And in truth, a part of me didn’t want to. It would have felt as if I were attempting to replace my dear Beatrice.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("Robert understood that. It was why his own mother would never remarry.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("“But now, when I look at my daughters…” Winslow blew out a long-suffering sigh. “I regret that decision.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("“Are they both out for the season?” Robert asked curiously. Polite conversation was expected. It was also essential that he get to know Winslow better so no surprises would arise later.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("“Yes.” The single word was spoken with grim chagrin. “But it’s their seventh and fifth seasons, and I’m afraid it might be too late.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("Robert blinked, stunned. Fifth and "), _c('i', [_vm._v("seventh")]), _vm._v("? Good Lord. He’d never heard of young ladies taking that many seasons to find a husband. Especially heiresses. Even if the two possessed second heads, he couldn’t fathom why fortune hunters weren’t pounding down the man’s door to get to them.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("“Didn’t both of your brothers wed last year?” Winslow inquired, knowing as well as every man in Mayfair that the Carlisle brothers had been picked off one by one. Robert was the last one standing from a threesome that had once been considered the bane of marriage-minded mamas everywhere.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("“They did.” "), _c('i', [_vm._v("And may God rest their bachelor souls.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_vm._v("Oh, they both seemed happy enough. Sebastian, especially, appeared more relaxed than he’d been in years, which was all due to his wife, Miranda. The perfect duchess she certainly wasn’t, although she’d proven completely perfect for Sebastian by being nothing he wanted in a wife yet everything he needed in a woman. His brother had gone happily over to the ranks of the enemy, doting on her like a smitten pup. The attention he heaped on her was now made all the worse by her being with child.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("His younger brother, Quinton, was little better. His wife, Annabelle, had him up to his neck in tenant leases, farm improvements, livestock, and crops, yet Quinn had never been more focused on his future and was happy to be shackled to a woman who was more than his match in wits and charm.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p86"
    }
  }, [_vm._v("“Are you planning to follow suit?” Winslow accepted a fresh drink from the attendant.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("Popping the cigar between his teeth, Robert firmly shook his head. “No reason to rush into captivity.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p88"
    }
  }, [_vm._v("His mother, however, had other ideas. Elizabeth Carlisle was beside herself with joy over having three of her four children happily married, two grandchildren already here and one more on the way—which meant she was determined to bring the same wedded bliss to Robert. Even if it killed him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("He dearly loved his mother. But while he would do anything to make her happy, he drew the line at proposing. Just as he would never enter into a bad business deal, he had no plans to enter into marriage. Especially since he’d come to believe that matrimony was simply another business arrangement, negotiated and bound by contract. Yet one a man could never escape when it went bad.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p90"
    }
  }, [_vm._v("“Didn’t you court General Morgan’s daughter last season?” Winslow asked. Apparently, Robert wasn’t the only one who had done his research for this meeting.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p91"
    }
  }, [_vm._v("“Yes,” he admitted, a touch ruefully. “But we mutually agreed to break off.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p92"
    }
  }, [_vm._v("And better for both that they did. Diana had gone on to be courted by the Duke of Wembley’s youngest son, and Robert had come to realize that he’d rather remain a bachelor. Their courtship had ended without rancor, the two remaining good acquaintances. A situation much to his relief, as he didn’t fancy having to face her brother Garrett over pistols at dawn.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p93"
    }
  }, [_vm._v("“Be assured that marriage is not in my future and that I will give my full attention to the company.” Robert exchanged his empty glass for the full one held out by the attendant and explained, “After all, I had the great fortune to be born a second son.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p94"
    }
  }, [_vm._v("Winslow guffawed so loudly that he drew an irritated glance from Lord Daubney, who sat in the corner reading the "), _c('i', [_vm._v("Times")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("“A second son with a happily married older brother—"), _c('i', [_vm._v("very")]), _vm._v(" happily married, you understand,” he clarified. That innuendo brought another laugh from Winslow. “I am a man in no danger of becoming an heir, so a man in no danger of needing a wife.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p96"
    }
  }, [_vm._v("But he "), _c('i', [_vm._v("was")]), _vm._v(" a man in desperate need of a partnership. And with this company, in particular. Winslow Shipping’s interests reached around the globe, with successful ventures in India, the Far East, and the Americas. Already the largest sole proprietorship in the empire, the company was poised to grow exponentially over the coming decades. Gaining a partnership with Winslow would be like finding the Golden Fleece. The best opportunity with the best business.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p97"
    }
  }, [_vm._v("And the very best way to prove to his father’s memory that he was worthy of the Carlisle name. Anything less would be failure.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p98"
    }
  }, [_vm._v("Which was one reason why he’d not disclosed his plans for the partnership with his family. They were already uneasy about his choice of making business his life’s path, rather than the usual posts available to second sons. But he couldn’t stomach the law or medicine, and he lacked the discipline necessary for the military and the moral fortitude for the church, with no desire to either end men’s lives or save their souls.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p99"
    }
  }, [_vm._v("Of course, the other reason he hadn’t told them was that they still blamed him for Richard Carlisle’s death. He knew they did. Because he still blamed himself.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("Pushing down the sickening guilt at the thought of that terrible night two years ago, he leaned forward, keen to nail down terms. “So you’re considering—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p101"
    }
  }, [_vm._v("A clatter went up outside. Angry shouts and jeers joined the loud rattle of running hooves approaching wildly down the cobblestone street.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p102"
    }
  }, [_vm._v("“What on earth?” Winslow frowned and stepped toward the tall window.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p103"
    }
  }, [_vm._v("Robert shoved himself out of his chair to join him, tossing the butt of his cigar into the fire. Lord Daubney dropped his newspaper as he finally gave up all hope of reading it and hurried over, joining the group of men gathered at the window, to stare down at the spectacle below.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p104"
    }
  }, [_vm._v("Daubney uttered in disbelief, “A phaeton—driven by a woman?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p105"
    }
  }, [_vm._v("“On St James’s Street!” The club manager was appalled.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p106"
    }
  }, [_vm._v("“That’s no woman,” another gentleman clarified with a disapproving shake of his head. “That’s the Hellion.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p107"
    }
  }, [_vm._v("Robert watched as the rig raced by. Oh, that was definitely the Hellion.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p108"
    }
  }, [_vm._v("He’d never spoken to the woman, nor ever laid eyes on her before, knowing her only from idle gossip. But it "), _c('i', [_vm._v("had")]), _vm._v(" to be her. No lady would have dared such a thing except her, the notorious woman who delighted in outraging the staid old guard of the "), _c('i', [_vm._v("ton")]), _vm._v(". And judging from the sight of her, she’d proven to be just as beautiful and brazen as the gossips claimed. Had she been at a ball, the dark beauty would have had gentlemen fighting among themselves like dogs to gain the favor of her attentions. But here, on the street that housed London’s most exclusive gentlemen’s clubs and where a respectable woman would never have dared to venture a slippered foot without a male companion, they openly jeered at her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p109"
    }
  }, [_vm._v("Robert couldn’t help but smile in admiration, despite knowing firsthand the kind of rumors such an outrageous act might rain down upon her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p110"
    }
  }, [_vm._v("“And that is why my daughter is in her seventh season,” Winslow muttered beneath his breath as the rest of the men returned to their seats, the excitement over.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p111"
    }
  }, [_vm._v("“Pardon?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p112"
    }
  }, [_vm._v("“That, Carlisle,” he explained, his back straightening under the weight of humiliation as he turned away from the window, “is my daughter Mariah.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p113"
    }
  }, [_vm._v("“The "), _c('i', [_vm._v("Hellion")]), _vm._v("?” Robert exclaimed before he could stop himself, flabbergasted. His mind ran wild searching for the woman’s name. Then it hit him—Mariah Winslow.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p114"
    }
  }, [_vm._v("Winslow Shipping and Trade.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p115"
    }
  }, [_c('i', [_vm._v("Christ.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p116"
    }
  }, [_vm._v("Winslow’s mouth pressed tight, seemingly offended less by the epithet that the gossips had branded on her and more by his daughter herself. “And beside her sat her sister, Evelyn, who is just as determined to mire herself in scandal.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p117"
    }
  }, [_vm._v("That certainly explained all those seasons without proposals, and judging by this latest antic, none would be forthcoming this year, either. If the Carlisle brothers were the scourge of Mayfair, these two were its female equivalent. Two young ladies who somehow managed to thumb their noses at the quality yet creatively skirt ruining their reputations completely.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p118"
    }
  }, [_vm._v("“I promised their mother on her deathbed that I would make proper ladies of them, but I’ve failed,” Winslow lamented with a deep frown. “Especially with Mariah. She has no interest in society events or housekeeping, in fashions or flowers…in none of the things that other young ladies enjoy.” He waved a dismissive hand. “Instead, she’d rather be working at the shipping offices, spending her time at the wharves with longshoremen and sailors, or wasting her allowance on urchins.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p119"
    }
  }, [_vm._v("Robert sympathized with the man, but he couldn’t help a touch of admiration for his daughters. They certainly weren’t part of the boring misses following the suffocating rules of the marriage market like lambs being led to slaughter. They should consider themselves lucky to have escaped the chains of domesticity that society shackled onto its young ladies, who were expected to do nothing more in life than host parties, birth heirs, and retire quietly into the countryside with their embroidery and watercolors.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p120"
    }
  }, [_vm._v("“What Mariah needs is a husband to settle her into proper womanhood,” Winslow muttered, rubbing at the knot of tension at his nape. “But I’ve no female relatives in society to give her introductions, so no chance of gaining appropriate suitors for her.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p121"
    }
  }, [_vm._v("Robert raised his glass to his lips and murmured dryly, “That’s a shame.” It was hard to commiserate with the man when his daughters had practically glowed with freedom as they’d raced past.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p122"
    }
  }, [_vm._v("Winslow faced Robert, his gaze hard. “But "), _c('i', [_vm._v("you")]), _vm._v(" do.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p123"
    }
  }, [_vm._v("He choked on his cognac. “"), _c('i', [_vm._v("What?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p124"
    }
  }, [_vm._v("“I need a partner with connections in the "), _c('i', [_vm._v("ton")]), _vm._v(" and the audacity to use them,” he said frankly, laying all his cards on the table. “Call on your relatives to guide Mariah through this season, and I’ll guarantee you a partnership. A twenty percent stake is yours if an offer is made from a respectable gentleman by the last day of Parliament.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p125"
    }
  }, [_vm._v("Robert gaped at him. The man was mad.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p126"
    }
  }, [_vm._v("And utterly serious.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p127"
    }
  }, [_vm._v("“A partnership,” Robert sputtered, echoing his words to make certain he understood him, “in exchange for marrying off your daughter?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p128"
    }
  }, [_vm._v("Winslow nodded curtly, frustration evident in every inch of him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p130"
    }
  }, [_vm._v("Robert stared at him, incredulous. The offer was preposterous. A test to prove his abilities wasn’t out of line, but "), _c('i', [_vm._v("this")]), _vm._v("? Good Lord.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p131"
    }
  }, [_vm._v("“There seems to be a mistake,” he drawled, forcing a half grin and doing his damnedest to keep his own aggravation from showing. Even now, with the partnership flung down onto the table for him to simply pick up, he felt the opportunity slipping through his fingers. “You’ve confused me with a matchmaking mama.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p132"
    }
  }, [_vm._v("Winslow shook his head. “Mariah’s behavior has to stop, for her own good, and I am at my wit’s end. Finding her a husband is the best way to save her from herself.” He pinned Robert beneath a hard gaze. “And you’re the man to do it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p133"
    }
  }, [_c('i', [_vm._v("Not")]), _vm._v(" at all the way he wanted to prove himself. Yet he was tempted. So "), _c('i', [_vm._v("very")]), _vm._v(" tempted. Especially when Winslow put it like that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p134"
    }
  }, [_vm._v("Mariah Winslow certainly wouldn’t find a good husband on her own, and he’d be doing only what other men had done for their female relatives for centuries—ensure a good marriage. And yes, to save her from herself. If she kept on as she was doing, remaining unmarried would be the least of her worries, because her antics would turn her into a social pariah. He’d seen women’s lives destroyed over far less scandalous things. It would be a damned shame if that happened to the Hellion.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p135"
    }
  }, [_vm._v("A much-needed marriage for her, a partnership for him…He’d be a fool to let his conscience interfere. Yet uncertainty gnawed at his gut that this might be a step too far in pursuing his goals.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p136"
    }
  }, [_vm._v("“Seven months to secure a suitable match doesn’t strike me as unreasonable for a man of your connections,” Winslow challenged, misreading his hesitation. “"), _c('i', [_vm._v("If")]), _vm._v(" you truly possess them as you claim.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p137"
    }
  }, [_vm._v("His eyes narrowed. “Be assured that I do.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p138"
    }
  }, [_vm._v("“Then come by the house tomorrow at eleven, and you’ll have the chance to prove it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p139"
    }
  }, [_vm._v("Oh, he could certainly meet this challenge. Easily. After all, Winslow’s daughter might be the Hellion, but she was also a shipping heiress with the beauty of an Incomparable. And he had his mother to help him, a dowager duchess longing for something more interesting to do this season than attend the same boring events. A few balls and teas, some new gowns, and even Mariah Winslow would be offered for by March. April at the latest. The partnership would be his, and he would finally prove himself worthy of the Carlisle name.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p140"
    }
  }, [_vm._v("“Agreed,” Robert said. “I won’t let you down.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p141"
    }
  }, [_vm._v("Winslow dubiously arched a brow, even as the two men shook hands.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p142"
    }
  }, [_vm._v("But Robert was confident, both in himself and in his mother’s matchmaking abilities. After all, if Sebastian and Quinton could be sent packing into matrimonial bliss within three months of each other, how hard could it be to marry off the Hellion by season’s end?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b3b93a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s005-Chapter-001.vue
// module id = 72
// module chunks = 0